import Dayjs from './dayjs';

export default class Unix extends Dayjs {}
